// extracted by mini-css-extract-plugin
module.exports = {"success-icon":"Exchanged_success-icon__3n6Ho","group":"Exchanged_group__NoyT-"};